import styled from "@emotion/styled";
import { lightGreen, lightGrey2, red } from "@stepfinance/react";
import type { FC, ReactNode } from "react";

import { ReactComponent as FailIcon } from "../../../assets/notifications/failIcon.svg";
import { ReactComponent as PendingIcon } from "../../../assets/notifications/pendingIcon.svg";
import { ReactComponent as SuccessIcon } from "../../../assets/notifications/successIcon.svg";
import { ExplorerLink } from "../../../components/ExplorerLink/ExplorerLink";
import type { MultiTxnNotificationStrings } from "../../../contexts/language/languageTypes";
import type { NotificationType } from "../../notifications";
import { notify } from "../../notifications";
import type { NotificationContent } from "./types";

const TransactionLink = styled.div<{ success: boolean | undefined }>`
  display: flex;
  align-items: center;
  a {
    color: ${({ success }) => (success === true ? lightGreen : success === undefined ? lightGrey2 : red)};
    font-style: normal;
    font-weight: normal;
    font-weight: 400;
    font-size: 14px !important;
    line-height: 22px;
    text-decoration: none;
  }
`;

const TransactionStateIcon: FC<{ state?: boolean }> = ({ state }) => {
  const iconSize = 24;
  return state === true ? (
    <SuccessIcon width={iconSize} height={iconSize} />
  ) : state === undefined ? (
    <PendingIcon width={iconSize} height={iconSize} />
  ) : (
    <FailIcon width={iconSize} height={iconSize} />
  );
};

export const sendMultiTxNotification = (
  txids: string[],
  txConfirmationStates: boolean[],
  {
    message,
    key,
    duration,
    type,
  }: { message: string | ReactNode[]; key: string; duration: number; type: NotificationType },
  notificationStrings: MultiTxnNotificationStrings,
) => {
  return notify({
    key,
    message,
    duration,
    type,
    description: (
      <>
        <span>{notificationStrings.transactionWasSplit.description}</span>
        {txids.map((t, index) => {
          return (
            <TransactionLinkContainer key={t}>
              <TransactionStateIcon state={txConfirmationStates[index]} />
              <TransactionLink key={t} success={txConfirmationStates[index]}>
                <ExplorerLink address={t} type="tx">
                  Transaction {index + 1}
                </ExplorerLink>
              </TransactionLink>
            </TransactionLinkContainer>
          );
        })}
      </>
    ),
  });
};

export const sendSuccessContent = (
  renderNotifications: boolean,
  signature: string,
  notificationContent: NotificationContent,
) => {
  if (renderNotifications) {
    if (typeof notificationContent === "function") {
      notificationContent(signature);
    } else {
      notify({
        ...notificationContent,
        type: "success",
        txId: signature,
      });
    }
  }
};

const TransactionLinkContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;
